import { Link, useLocation } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Home as HomeIcon, Package, Truck } from 'lucide-react'
import { useStytchOrganization } from '@stytch/react/b2b'

const Navigation = () => {
    const location = useLocation()
    const { organization } = useStytchOrganization()

    const isActiveRoute = (path: string) => {
        return location.pathname === path
    }

    return (
        <div className="flex items-center gap-8 h-full">
            {organization?.organization_name && (
                <Link to="/" className="flex items-center gap-2 font-normal text-xl text-primary-foreground">
                    <span>{organization?.organization_name}</span>
                </Link>
            )}
            <div className="flex items-center h-full">
                <Button
                    variant={isActiveRoute('/') ? 'secondary' : 'ghost'}
                    size="sm"
                    asChild
                    className={`h-full rounded-none ${isActiveRoute('/') ? 'text-secondary-foreground hover:bg-secondary' : 'text-primary-foreground hover:bg-primary-foreground/20'}`}
                >
                    <Link to="/" className="flex items-center gap-2">
                        <HomeIcon className="h-4 w-4" />
                        <span className="hidden md:inline">Home</span>
                    </Link>
                </Button>
                <Button
                    variant={isActiveRoute('/orders') ? 'secondary' : 'ghost'}
                    size="sm"
                    asChild
                    className={`h-full rounded-none ${isActiveRoute('/orders') ? 'text-secondary-foreground hover:bg-secondary' : 'text-primary-foreground hover:bg-primary-foreground/20'}`}
                >
                    <Link to="/orders" className="flex items-center gap-2">
                        <Package className="h-4 w-4" />
                        <span className="hidden md:inline">Orders</span>
                    </Link>
                </Button>
                <Button
                    variant={isActiveRoute('/live-tracking') ? 'secondary' : 'ghost'}
                    size="sm"
                    asChild
                    className={`h-full rounded-none ${isActiveRoute('/live-tracking') ? 'text-secondary-foreground hover:bg-secondary' : 'text-primary-foreground hover:bg-primary-foreground/20'}`}
                >
                    <Link to="/live-tracking" className="flex items-center gap-2">
                        <Truck className="h-4 w-4" />
                        <span className="hidden md:inline">Live Tracking</span>
                    </Link>
                </Button>
            </div>
        </div>
    )
}

export default Navigation
